import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../store';

@customElement('avanza-new-specsheet')
export class AvanzaNewSpecsheet extends connect(store)(LitElement) {

	static styles = [
		css`
		  :host {
			font-family: var(--font-family-light);
		  }
		`
	];
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
	}

	render() {
		return html`
			<shared-specsheet-page>
				<shared-technical-data-page></shared-technical-data-page>
			</shared-specsheet-page>
			<shared-specsheet-page>
				<shared-tender-text-page></shared-tender-text-page>
			</shared-specsheet-page>

		`;
	}
}
